import React, { useEffect, useState } from 'react'
import {Link, useLocation, useParams} from 'react-router-dom';
import NotFoundPage from './NotFoundPage';
import { isMobile } from 'react-device-detect';
import DateComponent from '../components/DateComponent';
import CouponDownloader from '../components/CouponDownloader';


export default function Blindbox(props) {
    const {blindboxList} = props;
    const param = useParams();
    var blindBoxId = param.id;
    const path = process.env.REACT_APP_STATIC_CDN_ASSETS_IUIU
    const [checked, setChecked] = useState([])
    const [select, setSelect] = useState({})
    const [blindboxes, setBlinboxes] = useState([])
    const rarityRating = {
        "Unclassified": "?",
        "Lame": "☆☆☆☆☆☆",
        "Basic": "★☆☆☆☆☆",
        "Common": "★★☆☆☆☆",
        "Uncommon": "★★★☆☆☆",
        "Rare": "★★★★☆☆",
        "Epic": "★★★★★☆",
        "Legendary": "★★★★★★"
    }

    const setCheckedBox = (value) =>{
        if(value==="all"){
            setChecked(blindboxList.filter(c=>c.id===blindBoxId)[0].checkList)
        }else{
            setChecked([...checked, value])
        }
    }

    const uniqueItem = checked.filter((item, index, self) => {
        const firstIndex = self.findIndex(i => i === item);
        
        return index === firstIndex;
    });

    const [revealedIds, setRevealedIds] = useState([]);

    const [rarityVisibility, setRarityVisibility] = useState(false); //revealRarity()

    const [emojiVisibility, setEmojiVisibility] = useState(false); //revealEmoji()

    
    const [turns, setTurns] = useState(0)
    const getLocalTimestampFormatted = () => {
        const now = new Date();

        // --- Date Components ---
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
        const day = String(now.getDate()).padStart(2, '0');

        // --- Time Components ---
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');

        // --- Final Construction ---
        return `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;
    }
    const handlePostGoogleSheet = async(select) => {
        console.log(select)
        const valuesJSON = [select.id, select.emoji, select.title, select.image, select.sponsor, select.receiver, select.rarity, 
            select?.attachment && select?.attachment[0]?.title ? select.attachment[0].title : "", 
            select?.attachment ? select.attachment[0].url && select.attachment[0].url : "", getLocalTimestampFormatted()]
        console.log("Google Sheet Values", valuesJSON)
        await fetch(process.env.REACT_APP_GOOGLE_SHEET_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            values: valuesJSON
        })
        // body: valuesJSON
        // body: JSON.stringify({
        //     values: ["Alice", "alice@example.com", 28, new Date().toISOString()]
        // })
        });

        const res = await fetch(process.env.REACT_APP_GOOGLE_SHEET_URL)
        const data = await res.json();
        console.log(data);
    }


    const unbox = (id) => {
        setRevealedIds(prevRevealedIds => {
            if (prevRevealedIds.includes(id)) {
                if(turns===0){
                    return prevRevealedIds.filter(itemId => itemId !== id);
                }else{
                    return prevRevealedIds;
                }
            }else {
                if(Object.keys(select).length >= 0){
                    //delay a bit so the user can watch the full animation
                    setTimeout(()=>{
                        addTurns(-1);
                        const blindbox = blindboxes.filter(b=>b.id===id)[0]
                        const instantFunctionObject = blindbox?.attachment && blindbox?.attachment.length>0 ? blindbox?.attachment.filter(a=>a.instantFunction)[0] : []
                        console.log("instantFunctionObject", instantFunctionObject)
                        setSelect(blindbox)
                        if(instantFunctionObject && instantFunctionObject.instantFunction && instantFunctionObject.instantFunction.length>0){
                            if(instantFunctionObject.instantFunction.startsWith("addTurns")){
                                addTurns(Number(instantFunctionObject.instantFunction.split(":")[1]))
                                console.log("turns ", turns+instantFunctionObject.instantFunction.split(":")[1])
                            }else if(instantFunctionObject.instantFunction.startsWith("revealEmoji")){
                                revealEmoji()
                            }else if(instantFunctionObject.instantFunction.startsWith("revealRarity")){
                                revealRarity()
                            }
                        }
                        console.log("select ", blindbox)
                        
                        const targetElement = document.getElementById("coupon");
                        if (targetElement) {
                            targetElement.scrollIntoView({
                                behavior: 'smooth',
                                block: 'center'
                            });
                            handlePostGoogleSheet(blindboxes.filter(b=>b.id===id)[0])
                        }
                    }, 800)
                    
                }
                console.log("reveal ", id);
                return [...prevRevealedIds, id];
            }
        });
    }

    function randomize(array) {
        return array.sort(() => Math.random() - 0.5);
    }

    function fisherYatesShuffle(array) {
        let randomIndex;
        let fixedPositionArray = array.filter(i=>i.position)
        let remainder = array.filter(i=>!i.position)
        let currentIndex = remainder.length;

        console.log("remainder.length", remainder.length)
        console.log("array.length", array.length)

        console.log("fixedPositionArray", fixedPositionArray)
        console.log("remainder", remainder)

        // While there remain elements to shuffle.
        while (currentIndex !== 0) {

            // Pick a remaining element.
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex--;

            // And swap it with the current element.
            [remainder[currentIndex], remainder[randomIndex]] = [
                remainder[randomIndex], remainder[currentIndex]
            ];
        }
        console.log("shuffled remainder", remainder)
        
        fixedPositionArray.sort((a, b) => a.position - b.position);

        console.log("sorted fixedPositionArray", fixedPositionArray)


        fixedPositionArray.map(i=>remainder.splice(i.position-1, 0, i))

        console.log("shuffled + added fixed position boxes", remainder)

       

        return remainder;
    }

    const handleUnboxing = (box) => {
        if(turns>0 && Object.keys(select).length>0){
            if(revealedIds.includes(box.id)){
                setSelect(box)
                const targetElement = document.getElementById("coupon");
                if (targetElement) {
                    targetElement.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center' // Scrolls to center the element vertically
                    });
                    console.log(`Successfully scrolled to item ID: ${box.id}`);
                }
            }
            else{
                // const targetElement = document.getElementById("nextTurnButton");
                // if (targetElement) {
                //     targetElement.scrollIntoView({
                //         behavior: 'smooth',
                //         block: 'center'
                //     });
                //     console.log(`turns: ${turns}`);
                //     targetElement.style.background = "#000";
                //     targetElement.style.color = "#fff";
                //     setTimeout(() => {
                //         targetElement.style.background = "#fff"; 
                //         targetElement.style.color = "#000";
                //     }, 500);
                // }
                unbox(box.id)
            }
        }else{
            unbox(box.id)
            const targetElement = document.getElementById(box.id);
            if (targetElement) {
                targetElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center' // Scrolls to center the element vertically
                });
                console.log(`Successfully scrolled to item ID: ${box.id}`);
            }
        }
        
    };
    

    const [randomBlindboxes, setRandomBlindboxes] = useState([])

    const tryAgain = () =>{
        console.log("try again")
        setSelect({})
    }

    const revealRarity = () =>{
        tryAgain();
        console.log("reveal rarity");
        setRarityVisibility(true);
    }
    
    const revealEmoji = () =>{
        tryAgain();
        console.log("reveal emoji");
        setEmojiVisibility(true);
    }

    const nextTurn = () => {
        tryAgain()
        console.log("next turn")
        // setTurns(turns-1)
    }

    const addTurns = (count) => {
        setTurns(turns+count);   
    }

    const addTurnsAndContinue = (count) => {
        setTurns(turns+count);
        setSelect({})
    }

    const unboxRandomBox = (id) => {
        // blindboxes.filter(box=> )
        setRevealedIds(prevRevealedIds => {
            if (prevRevealedIds.includes(id)) {
                if(turns===0){
                    return prevRevealedIds.filter(itemId => itemId !== id);
                }else{
                    return prevRevealedIds;
                }
            }else {
                if(Object.keys(select).length === 0){
                    //delay a bit so the user can watch the full animation
                    setTimeout(()=>{
                        setSelect(blindboxes.filter(b=>b.id===id)[0])
                        console.log("select ", blindboxes.filter(b=>b.id===id)[0])
                        
                        const targetElement = document.getElementById("coupon");
                        if (targetElement) {
                            targetElement.scrollIntoView({
                                behavior: 'smooth',
                                block: 'center'
                            });
                        }
                    }, 800)
                    
                }
                console.log("reveal ", id);
                return [...prevRevealedIds, id];
            }
        });
    }

    useEffect(()=>{
        // if(blindboxList){
        //     setBlindbox(blindboxList.filter(c=>c.id===blindBoxId)[0])
        //     console.log(blindboxList.filter(c=>c.id===blindBoxId)[0])
        // }
        // blindboxList && setRandomBlindboxes(randomize(blindboxList.filter(c=>c.id===blindBoxId)[0].blindboxes))
        if(blindboxList && blindboxList.filter(c=>c.id===blindBoxId)[0].checkList.length === uniqueItem.length && blindboxes.length === 0){
            setBlinboxes(fisherYatesShuffle(blindboxList.filter(c=>c.id===blindBoxId)[0].blindboxes))
            setTurns(blindboxList.filter(c=>c.id===blindBoxId)[0].turns)
        }
        console.log(checked)
    }, [blindboxList, checked, revealedIds, randomBlindboxes, select, blindboxes, turns])
    return (
        <div className=''>
            {blindboxList && blindboxList?.length>0 ? (
            <div className="row center" style={{padding: "1rem", background: `url(${path}/${blindboxList.filter(c=>c.id===blindBoxId)[0]?.backgroundImage[0]})`, backgroundSize: "contain", backgroundPosition: "center", fontSize: "1rem", border: "solid orange 1rem", borderRadius: "1rem"}}>
                {
                    blindboxList.filter(c=>c.id===blindBoxId)[0].checkList.length > uniqueItem.length && 
                    <div className="">
                        {blindboxList.filter(c=>c.id===blindBoxId)[0].checkList.map(box=>
                            <div className='row checkList full'>
                                <label className='row' for={box.title}>
                                    <div>
                                        <input type="checkbox" id={box.title} name={box.title} value={box.title} onChange={(e)=>setCheckedBox(e.target.value)}></input>
                                    </div>
                                    <div style={{marginLeft: "1rem"}}>{box.title}</div>
                                </label>
                            </div>
                        )}
                        <div className='row checkList full'>
                            <label className='row' for="all">
                                <div>
                                    <input type="checkbox" id="all" name="all" value="all" onChange={(e)=>setCheckedBox(e.target.value)}></input>
                                </div>
                                <div style={{marginLeft: "1rem"}}>Chọn tất cả</div>
                            </label>
                        </div>
                </div>}
                {
                    blindboxList.filter(c=>c.id===blindBoxId)[0].checkList.length === uniqueItem.length && 
                    <div className='row full blindboxPanel'>
                        {select !== null && 
                        <CouponDownloader addTurnsAndContinue={addTurnsAndContinue} turns={turns} nextTurn={nextTurn} revealRarity={revealRarity} revealEmoji={revealEmoji} tryAgain={tryAgain} rarityRating={rarityRating} box={select} stamp={path+"/"+blindboxList.filter(c=>c.id===blindBoxId)[0].signed.stamp} signature={path+"/"+blindboxList.filter(c=>c.id===blindBoxId)[0].signed.signature} validity={blindboxList.filter(c=>c.id===blindBoxId)[0].validity}></CouponDownloader>}
                        {
                            blindboxes.map((box, i)=>
                            <div className='row'>
                                <div id={box.id}
                                    className={`interactiveText blindboxBag ${revealedIds && revealedIds.length>0 && revealedIds.includes(box.id) ? "open" : "close"} ${select.id===box.id && "selected"} ${revealedIds.includes(box.id) ? box.rarity.toLowerCase() : "Nothing"}Bag `} for={box.title} onClick={()=>handleUnboxing(box)}>
                                    <div>
                                        {((revealedIds && revealedIds.length>0 && !revealedIds.includes(box.id)) || (revealedIds && revealedIds.length === 0)) && <div className='blindboxIndex'>{i+1}</div>}
                                        {revealedIds && revealedIds.length>0 && revealedIds.includes(box.id) ? box.emoji : 
                                        <div style={{background: `url(${path+"/"+box.image})`, width: "10rem", height: "10rem", backgroundSize: "contain"}}>
                                        </div>}
                                        {/* <input className='blindbox' type="button" id={box.id} name={box.title} value={revealedIds && revealedIds.length>0 && revealedIds.includes(box.id) ? "Đóng Blindbox" : "Mở Blindbox"}
                                            onClick={()=>unbox(box.id)}
                                        ></input> */}
                                    </div>
                                    {emojiVisibility && revealedIds && revealedIds.length>0 && !revealedIds.includes(box.id) && <div className={`row center rarityRevealBox`} style={{background: "#fff", paddingLeft: "1rem", paddingRight: "1rem"}}>{box.emoji}</div>}
                                    {rarityVisibility && revealedIds && revealedIds.length>0 && !revealedIds.includes(box.id) && <div className={`row center rarityRevealBox ${box.rarity.toLowerCase()}Class class`}>{box.rarity}</div>}
                                    {revealedIds && revealedIds.length>0 && revealedIds.includes(box.id) && <div className='col'>
                                        <div style={{marginLeft: "1rem"}}><b>{box.title}</b></div>
                                        <div style={{marginLeft: "1rem", fontStyle: "italic", color: "#000"}}>Nhà tài trợ: {box.sponsor}</div>
                                        <div style={{marginLeft: "1rem", fontStyle: "italic", color: "#000"}}>Người thụ hưởng: {box.receiver}</div>
                                        <div style={{fontStyle: "italic"}}><img style={{width: "10rem"}} className='' src={path+"/"+box.image}></img></div>
                                        <div className='row center' style={{fontSize: "2rem"}}>{rarityRating[box.rarity]}</div>
                                        <div className={box.rarity.toLowerCase()+"Class class"}>{box.rarity}</div>
                                        {
                                            box.attachment && box.attachment.length>0 && box.attachment && 
                                            <div style={{fontStyle: "italic", color: "#000", fontSize: "0.7rem"}}>(*)Có {box.attachment.length} tệp đính kèm</div>
                                        }  
                                    </div>}
                                </div>
                            </div>
                            )
                        }
                    </div>
                }
            </div>): <NotFoundPage/> }
            <div className="row center">
                 <Link to='/'>Back to Homepage</Link>   
            </div>
        </div>
    )
}
